<template>
    <div class="searchResults-view">
        <div class="searchResults-view-mask">
            <h5 class="searchResults-view-header">
                <i class="warning-icon"/>
                {{ langTransfer(warningText) }}
            </h5>
            <div ref="searchResultsListWrapper" class="searchResults-list-wrapper">
                <div :class="searchResultsListClassName" class="searchResults-list-body">
                    <div v-if="resourceListData.ItemCount === 0" class="no-results">
                        <img src="@/assets/hasNoRes.png">
                        <p>没有找到相关内容，换个关键词试试</p>
                    </div>
                    <div class="list-body-mask">
                        <template v-if="resourceType === 'audio' || resourceType === 'video'">
                            <div v-for="(item,index) in resourceListData.Data"
                                 :key="index"
                                 class="list-item"
                                 @click="goDetail(item)">
                                <img :src="item.__cover">
                                <div class="list-item-infos">
                                    <h5>{{ item.Name }}</h5>
                                    <p>{{ item.Intro }}</p>
                                    <i>{{ item.__bottomInfo }}</i>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="resourceType ==='articleLibrary'">
                             <div v-for="(item,index) in resourceListData.Data"
                                 :key="index"
                                 class="list-item"
                                 @click="goTextReading(item)">
                                <div class="list-item-infos">
                                    <h5 v-html="item.Title"></h5>
                                    <p  v-html="item.Summary"></p>
                                    <i>【{{item.MagazineName}}】{{item.Year}}年{{item.Issue}}期</i>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(item,index) in resourceListData.Data"
                                 :key="index"
                                 class="list-item"
                                 @click="goDetail(item)">
                                <img :src="item.__cover">
                                <h5>{{ item.Name }}</h5>
                                <span>{{ item.__midInfo }}</span>
                            </div>
                            <div class="list-item" style="height: 0;"/>
                            <div class="list-item" style="height: 0;"/>
                            <div class="list-item" style="height: 0;"/>
                            <div class="list-item" style="height: 0;"/>
                        </template>
                    </div>
                    <div v-show="isPending"
                         class="loader">
                        <svg id="Layer_1"
                             version="1.1"
                             xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             x="0px"
                             y="0px"
                             width="48px"
                             height="60px"
                             viewBox="0 0 24 30"
                             style="enable-background:new 0 0 50 50;"
                             xml:space="preserve">
                            <rect :fill="themeColor"
                                  x="0"
                                  y="10"
                                  width="4"
                                  height="10"
                                  opacity="0.2">
                                <animate attributeName="opacity"
                                         attributeType="XML"
                                         values="0.2; 1; .2"
                                         begin="0s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                                <animate attributeName="height"
                                         attributeType="XML"
                                         values="10; 20; 10"
                                         begin="0s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                                <animate attributeName="y"
                                         attributeType="XML"
                                         values="10; 5; 10"
                                         begin="0s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                            </rect>
                            <rect :fill="themeColor"
                                  x="8"
                                  y="10"
                                  width="4"
                                  height="10"
                                  opacity="0.2">
                                <animate attributeName="opacity"
                                         attributeType="XML"
                                         values="0.2; 1; .2"
                                         begin="0.15s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                                <animate attributeName="height"
                                         attributeType="XML"
                                         values="10; 20; 10"
                                         begin="0.15s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                                <animate attributeName="y"
                                         attributeType="XML"
                                         values="10; 5; 10"
                                         begin="0.15s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                            </rect>
                            <rect :fill="themeColor"
                                  x="16"
                                  y="10"
                                  width="4"
                                  height="10"
                                  opacity="0.2">
                                <animate attributeName="opacity"
                                         attributeType="XML"
                                         values="0.2; 1; .2"
                                         begin="0.3s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                                <animate attributeName="height"
                                         attributeType="XML"
                                         values="10; 20; 10"
                                         begin="0.3s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                                <animate attributeName="y"
                                         attributeType="XML"
                                         values="10; 5; 10"
                                         begin="0.3s"
                                         dur="0.6s"
                                         repeatCount="indefinite" />
                            </rect>
                        </svg>
                    </div>
                    <div class="site-footer">
                      <Footer/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import Footer from '@/components/footer'
    export default {
        components: {
          Footer
        },
        data () {
            return {
                searchResultsBScroll: null,
                resourceType: '',
                searchWord: '',
                searchType:'',
                resourceListData: {},
                typesMap: {
                    magazine: {
                        text: '期刊',
                        endWord: '本'
                    },
                    book: {
                        text: '图书',
                        endWord: '本'
                    },
                    audio: {
                        text: '音频',
                        endWord: '部'
                    },
                    video: {
                        text: '视频',
                        endWord: '部'
                    },
                    newspaper:{
                       text: '报纸',
                       endWord: '种' 
                    },
                    articleLibrary:{
                       text: '文章',
                       endWord: '篇' 
                    }
                },
                lastParams: {},
                isPending: true
            }
        },
        computed: {
            types () {
                const { resourceType } = this
                return this.allTypes[resourceType]
            },
            searchResultsListClassName () {
                const { resourceType } = this
                return {
                    'audio-likely': resourceType === 'audio',
                    'video-likely': resourceType === 'video',
                    'book-likely': resourceType === 'book',
                    'magazine-likely': resourceType === 'magazine',
                    'newspaper-likely': resourceType === 'newspaper',
                    'articleLibrary-likely': resourceType === 'articleLibrary'
                }
            },
            warningText () {
                const {
                    searchWord, typesMap, resourceType, resourceListData
                } = this

                if (typesMap && resourceType && resourceListData.ItemCount !== undefined) {
                    return `共搜索到“ ${ searchWord
                    } ”相关${ typesMap[resourceType].text }  ${
                        resourceListData.ItemCount
                    }  ${ typesMap[resourceType].endWord }`
                }

                return '搜索中...'
            },
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        activated () {
        },
        mounted () {
            this.initBScroll()
        },
        methods: {
            goTextReading(item){
                const params = {
                    resourceType:'magazine',
                    id:item.MagazineGuid,
                    year:item.Year,
                    issue:item.Issue,
                    articleId: item.ArticleID,
                    token:'token'
                }
                this.$router.push({
                    name: 'textReading',
                    params
                })
            },
            initBScroll () {
                this.$nextTick(() => {
                    this.searchResultsBScroll = new BScroll(this.$refs.searchResultsListWrapper, {
                        bounce: false,
                        click: true,
                        pullUpLoad: {
                            threshold: 150
                        },
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                    this.searchResultsBScroll.on('pullingUp', () => {
                        try {
                            this.pullUpLoadHandler()
                        } catch (error) {
                            console.log(error)
                        }
                    })
                })
            },
            async getListByWord (pageindex = 1, pagesize = 18) {
                try {
                    this.isPending = true
                    const { searchWord, resourceType, resourceListData } = this
                    const data = await this.$apis(resourceType)
                        .searchWord(searchWord, pageindex, pagesize)
                    this.isPending = false
                    const toolFnName = `format${ this.$tools.forMatFirstWord(resourceType) }Data`
                    data.Data = data.Data ? this.$tools[toolFnName](data.Data) : []
                    if (resourceListData.Data && resourceListData.Data.length > 0) {
                        data.Data = resourceListData.Data.concat(data.Data)
                        this.searchResultsBScroll.finishPullUp()
                    }
                    this.resourceListData = data
                } catch (error) {
                    this.isPending = false
                    console.log(error)
                }
            },
            pullUpLoadHandler () {
                const {
                    resourceListData, searchResultsBScroll
                } = this
                const { ItemCount } = resourceListData
                const { Data, PageIndex } = resourceListData
                if (Data && Data.length < ItemCount) {
                    this.getListByWord(PageIndex + 1)
                    return
                }

                searchResultsBScroll.finishPullUp()
            },
            goDetail (item) {
                const { resourceType } = this
                this.$tools.goDetailRoute.call(this, resourceType, item)
            }
        },
        beforeRouteUpdate (to, from, next) {
            const { resourceType, searchWord } = to.params
            this.searchWord = searchWord
            this.resourceType = resourceType
            this.resourceListData = {}
            this.getListByWord()
            next()
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { params } = vm.$route
                if (vm.$tools.isSameParams(params, vm.lastParams)) {
                    return
                }
                vm.lastParams = params
                const { resourceType, searchWord } = params
                vm.searchWord = searchWord
                vm.resourceType = resourceType
                vm.resourceListData = {}
                vm.getListByWord()
            })
        }
    }
</script>

<style lang="scss" scoped>
    .searchResults-view {
        width: 1140px;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 20px;
        position: relative;
    }

    .searchResults-view-mask {
        width: 1140px;
        position: absolute;
        top: 20px;
        bottom: 20px;
        left: 0;
        right: 0;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .searchResults-view-header {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        background: #fff;
        border-bottom: 1px solid #F0F2F7;
        padding-left: 28px;
        
        font-size: 16px;
        color: #1A1A1A;
        line-height: 50px;
        position: relative;

        .warning-icon {
            display: block;
            width: 4px;
            height: 16px;
            background: #0084FF;
            border-radius: 2px;
            position: absolute;
            left: 16px;
            top: 17px;
        }
    }

    .searchResults-list-wrapper {
        position: absolute;
        top: 50px;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .site-footer {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .magazine-likely.searchResults-list-body, .book-likely.searchResults-list-body,
        .newspaper-likely.searchResults-list-body
         {
        position: relative;
        min-height: 100%;
        box-sizing: border-box;
        padding: 16px 0 128px 34px;

        .list-body-mask {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }

        .list-item {
            width: 150px;
            height: 248px;
            margin-bottom: 16px;
            margin-right: 34px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;

            img {
                width: 150px;
                height: 190px;
                border-radius: 4px;
                cursor: pointer;
                box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
                background: #f6f6f6;
            }

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                margin: 14px 0 8px;
                cursor: pointer;
            }

            span {
                display: block;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
                max-width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .audio-likely.searchResults-list-body,.video-likely.searchResults-list-body,.articleLibrary-likely.searchResults-list-body{
        position: relative;
        min-height: 100%;
        box-sizing: border-box;
        padding: 8px 24px 128px;

        .list-body-mask {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }

        .list-item {
            width: 100%;
            height: 119px;
            border-bottom: 1px solid #F0F2F7;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            img {
                display: block;
                width: 80px;
                height: 80px;
                box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
                border-radius: 2px;
                cursor: pointer;
                margin-right: 16px;
                background: #f6f6f6;
            }
        }

        .list-item-infos {
            width: 996px;
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 22px;

            h5 {
                width: fit-content;
                
                font-size: 18px;
                color: #1A1A1A;
                line-height: 18px;
                margin-top: 4px;
                cursor: pointer;
            }

            p {
                width: fit-content;
                max-width: 100%;
                
                font-size: 16px;
                color: #79808B;
                line-height: 16px;
                height: 16px;
                margin: 8px 0 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }

            i {
                width: fit-content;
                display: block;
                font-style: normal;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
                overflow: hidden;
                height: 14px;
            }

        }

        .list-item:last-child {
            border-bottom: none;
        }
    }

    .no-results {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        padding-bottom: 129px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            width: 202px;
        }

        p {
            
            font-size: 18px;
            color: #999999;
            text-align: center;
            margin-top: 30px;
        }
    }

    .loader {
        width: 100%;
        height: 90px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>
